import { defineStore } from 'pinia';
import { useKeycloakStore } from './keycloak.js';

export const useStripeStore = defineStore('stripe', {
  state: () => ({
    publishableKey: '',
    accountSession: '',
    checkout_session: '',
  }),
  persist: true,

  actions: {
    async getStripePublicKey() {
      const { default: axios } = await import('axios');
      const path = import.meta.env.VITE_APP_URL + 'stripe';
      try {
        const { data } = await axios.get(`${path}/public-key`);
        this.publishableKey = data;
      } catch (err) {
        console.log(err.response?.data || err);
      }
    },

    async stripeOnbordingRedirect(payload) {
      const { default: axios } = await import('axios');
      const { f7 } = await import('framework7-vue');
      const { Browser } = await import('@capacitor/browser');
      const { Capacitor } = await import('@capacitor/core');
      const path = import.meta.env.VITE_APP_URL + 'stripe';
      try {
        const { data } = await axios.get(`${path}/onboard/refresh`, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
          params: { accountId: payload },
        });
        const accountLink = data.body;
        f7.dialog.confirm(
          `Click on link to add your bank account to receive payout <a href="${accountLink.url}">${accountLink.url}</a>?`,
          () => {
            if (accountLink?.url) {
              if (Capacitor.isPluginAvailable('Browser')) {
                Browser.open({ url: accountLink.url });
              } else {
                window.location.assign(accountLink.url);
              }
            }
          }
        );
      } catch (err) {
        console.log(err);
      }
    },

    async stripeCreateLoginLinks(payload) {
      const { default: axios } = await import('axios');
      const { Browser } = await import('@capacitor/browser');
      const { Capacitor } = await import('@capacitor/core');
      const path = import.meta.env.VITE_APP_URL + 'stripe';
      try {
        const { data } = await axios.get(`${path}/login_links`, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
          params: { accountId: payload },
        });
        const accountLink = data.body;
        if (accountLink?.url) {
          if (Capacitor.isPluginAvailable('Browser')) {
            Browser.open({ url: accountLink.url });
          } else {
            window.location = accountLink.url;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    async stripeAccountLinks(payload) {
      const { default: axios } = await import('axios');
      const { Browser } = await import('@capacitor/browser');
      const { Capacitor } = await import('@capacitor/core');
      const path = import.meta.env.VITE_APP_URL + 'stripe';
      try {
        const { data } = await axios.get(`${path}/account_links`, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
          params: { accountId: payload.accountId, actionType: payload.actionType },
        });
        const accountLink = data.body;
        if (accountLink?.url) {
          if (Capacitor.isPluginAvailable('Browser')) {
            Browser.open({ url: accountLink.url });
          } else {
            window.location = accountLink.url;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    async createStripeAccountSession(payload) {
      const { default: axios } = await import('axios');
      const path = import.meta.env.VITE_APP_URL + 'stripe';
      try {
        const { data } = await axios.post(`${path}/account_session`, null, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
          params: { accountId: payload },
        });
        this.accountSession = data;
      } catch (err) {
        console.log(err.response?.data || err);
      }
    },

    async deleteStripeAccount(payload) {
      const { default: axios } = await import('axios');
      const path = import.meta.env.VITE_APP_URL + 'stripe';
      try {
        await axios.delete(`${path}/delete_account`, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
          params: { accountId: payload },
        });
      } catch (err) {
        console.log(err);
      }
    },

    async createCheckOutSession(payload) {
      const { default: axios } = await import('axios');
      const { Browser } = await import('@capacitor/browser');
      const { Capacitor } = await import('@capacitor/core');
      const path = import.meta.env.VITE_APP_URL + 'stripe';
      try {
        const { data } = await axios.post(`${path}/checkout_session`, payload, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.checkout_session = data;
        if (data?.url) {
          if (Capacitor.isPluginAvailable('Browser')) {
            Browser.open({ url: data.url });
          } else {
            window.location.assign(data.url);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getCheckOutSessionStatus(payload) {
      const { default: axios } = await import('axios');
      const path = import.meta.env.VITE_APP_URL + 'stripe';
      try {
        const { data } = await axios.get(`${path}/checkout_session`, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
          params: { session_id: payload },
        });
        this.checkout_session = data;
      } catch (err) {
        console.log(err);
      }
    },
  },
});
